import axios from "axios";
import { Message } from "element-ui";
import { getAesString , decryptAesString} from "@/utils/encryption";
import router from '@/router'
import Vue from "vue";
const st = new Vue

const service = axios.create({
  baseURL: process.env.VUE_APP_baseURL,
  timeout: 20 * 1000,
});


/** 请求拦截器 */
service.interceptors.request.use(
    (config) => {
      //加密
      let to = localStorage.getItem("token")
      if (config.url !== "/index/upload") {
        if (to) {
          config.data.token = to
          config.data = { data: getAesString(config.data) }
        } else {
          config.data = { data: getAesString(config.data) }
        }
      } else {
        if (to) {
          config.data = { data: config.data }
        } else {
          config.data = { data: config.data }
        }
      }

      return config;
    },
    (error) => {
      Promise.reject(error);
    }
);


/** 响应拦截器 */
service.interceptors.response.use(
  (response) => {
    let stc
    
    //接收到响应数据并成功后的一些共有的处理，关闭loading等
    if(response.config.url=="/Qcc/enterpriseExport"){
      stc = response.data
    } else {
      stc = decryptAesString(response.data)
    }

    if (stc.code == 3) {
      localStorage.removeItem("token");
      localStorage.removeItem("name");
      localStorage.removeItem("dataList");
      router.push("/")
      st.$message({
        type: 'error',
        message: "登录失效，请重新登录."
      })
    } else if (stc.code == 2) {
      st.$message({
        type: 'error',
        message: stc.msg
      })
    }else if (stc.code == 1) {
      st.$message({
        type:'error',
        message: stc.msg
      })
    }


    return stc;

  },
  (error) => {
    /* ****  接收到异常响应的处理开始  **** */
    if (error && error.response) {
      // 1. 公共错误处理
      // 2. 根据响应码具体处理
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case 401:
          error.message = "未授权，请重新登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = "请求错误,未找到该资源";
          st.$router.push('/404')
          // window.location.href = "/NotFound";
          break;
        case 405:
          error.message = "请求方法未允许";
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "网络错误";
          localStorage.removeItem("token");
          localStorage.removeItem("name");
          localStorage.removeItem("dataList");
          router.push("/")
          st.$message({
            type: 'error',
            message: "登录失效，请重新登录."
          })
          break;
        case 501:
          error.message = "网络未实现";
          localStorage.removeItem("token");
          localStorage.removeItem("name");
          localStorage.removeItem("dataList");
          router.push("/")
          st.$message({
            type: 'error',
            message: "登录失效，请重新登录."
          })
          break;
        case 502:
          error.message = "网络错误";
          localStorage.removeItem("token");
          localStorage.removeItem("name");
          localStorage.removeItem("dataList");
          router.push("/")
          st.$message({
            type: 'error',
            message: "登录失效，请重新登录."
          })
          break;
        case 503:
          error.message = "服务不可用";
          localStorage.removeItem("token");
          localStorage.removeItem("name");
          localStorage.removeItem("dataList");
          router.push("/")
          st.$message({
            type: 'error',
            message: "登录失效，请重新登录."
          })
          break;
        case 504:
          error.message = "网络超时";
          localStorage.removeItem("token");
          localStorage.removeItem("name");
          localStorage.removeItem("dataList");
          router.push("/")
          st.$message({
            type: 'error',
            message: "登录失效，请重新登录."
          })
          break;
        case 505:
          error.message = "http版本不支持该请求";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
      }
    } else {
      // 超时处理
      if (JSON.stringify(error).includes("timeout")) {
        Message.error("服务器响应超时，请刷新当前页");
      }
      Message.error("连接服务器失败");
      error.message = "网络超时";
      localStorage.removeItem("token");
      localStorage.removeItem("name");
      localStorage.removeItem("dataList");
      router.push("/")
      st.$message({
        type: 'error',
        message: "登录失效，请重新登录."
      })
    }

    Message.error(error.message + '请求失败');

    /* ****  处理结束  **** */
    // 如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response);
  }
);



export default service












